import React from 'react'
import Banner from '../../components/nextgadget/banner'
import BestSeller from '../../components/nextgadget/best_seller'
import Brand from '../../components/nextgadget/brand'
import Carousel from '../../components/nextgadget/carousel'
import NewArrival from '../../components/nextgadget/new_arrival'
import Products from '../../components/nextgadget/products'
import Test from '../../components/nextgadget/test'
import Promotion from '../../components/nextgadget/promotion'

const HomePage = () => {
  return (
    <>
      <Carousel />
      <Promotion/>
      <BestSeller />
      <Test />
      <Brand />
    </>
  )
}

export default HomePage
